import * as Styles from "../CustomTable.styles";

interface CustomTableFooterProps {
  numberOfItems: number;
  productQuantityFormatted: string;
}

export default function CustomTableFooter({ numberOfItems, productQuantityFormatted }: CustomTableFooterProps) {
  return (
    <Styles.CustomTableFooter elevation={0}>
      <Styles.TableFooterContainer>
        <Styles.TableFooterTitle>Número de itens: </Styles.TableFooterTitle>
        <Styles.TableFooterNumber>{numberOfItems}</Styles.TableFooterNumber>
      </Styles.TableFooterContainer>
      <Styles.TableFooterContainer>
        <Styles.TableFooterTitle>Quantidade total: </Styles.TableFooterTitle>
        <Styles.TableFooterNumber>{productQuantityFormatted}</Styles.TableFooterNumber>
      </Styles.TableFooterContainer>
    </Styles.CustomTableFooter>
  );
}
